// extracted by mini-css-extract-plugin
module.exports = {"not-found-container":"not-found_not-found-container__1h87i","not-found__title":"not-found_not-found__title__sXsbo"};